import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { paths } from '@mc/paths'

const SubcategoryNavigation = dynamic(() =>
  import('./consumer').then((m) => m.SubcategoryNavigation),
)

const EnterpriseNavigation = dynamic(
  () => import('./enterprise/EnterpriseNavigation'),
)

export const Navigation = () => {
  const { pathname } = useRouter()

  if (pathname.includes(paths.enterpriseHomepage))
    return <EnterpriseNavigation />

  return <SubcategoryNavigation />
}
